export class CommCard
{
    constructor(json: any)
    {
        Object.assign(this, json);

        if (json.WhenCreated) this.WhenCreated = new Date(json.WhenCreated);
        if (json.WhenLastUpdated) this.WhenLastUpdated = new Date(json.WhenLastUpdated);
    }

    public BootVersion: number;
    public DeviceId: number;
    public DeviceTypeId: number;
    public FirmwareDescription: string;
    public FirmwareVersion: number;
    public FirmwareVersionId: number;
    public HardwareVersion: number;
    public Id: number;
    public IsLatest: number;
    public LatestFirmwareVersion: number;
    public SmartConnectId: number;
    public UId: string;
    public WhenCreated: Date;
    public WhenLastUpdated: Date;

}
